import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Grid,
  Typography,
} from '@material-ui/core';

function Header({ className, ...rest }) {
  return (
    <Grid
      className={clsx(className)}
      container
      justifyContent="space-between"
      spacing={3}
      {...rest}
    >
    <Grid item>
      <Grid container spacing= {1}>
        <Grid item>
          <Typography
            variant="h3"
            color="textSecondary"
            >
            Editar
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant="h3"
            color="textPrimary"
          >
            Modularización
          </Typography>
      </Grid>
      </Grid>
    </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
